var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShuomingXian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 6.5,
    transform: "matrix(1 0 0 -1 8 8)",
    stroke: "#3F465C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3V7",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 4.9a.6.6 0 10-1.2 0 .6.6 0 001.2 0z",
    fill: "#3F465C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSByPSI2LjUiIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDggOCkiIHN0cm9rZT0iIzNGNDY1QyIvPgo8cGF0aCBkPSJNOCAxMS4zVjcuMDAwMDYiIHN0cm9rZT0iIzNGNDY1QyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik04LjU5OTk5IDQuOUM4LjU5OTk5IDQuNTY4NjMgOC4zMzEzNiA0LjMgNy45OTk5OSA0LjNDNy42Njg2MiA0LjMgNy4zOTk5OSA0LjU2ODYzIDcuMzk5OTkgNC45QzcuMzk5OTkgNS4yMzEzNyA3LjY2ODYyIDUuNSA3Ljk5OTk5IDUuNUM4LjMzMTM2IDUuNSA4LjU5OTk5IDUuMjMxMzcgOC41OTk5OSA0LjlaIiBmaWxsPSIjM0Y0NjVDIi8+Cjwvc3ZnPgo=";
export { SvgTongyongShuomingXian as ReactComponent };